import { UiEvents } from '@jumpcloud/ui-events-vue';
import { ga } from 'client/util';
import EventManager from 'client/GrowthEngineering/EventManager';
import GlobalEventBus from 'client/EventBus/GlobalEventBus';
import LoggingService from 'client/util/LoggingService';
import hashString from 'client/GrowthEngineering/utilities/hashString';

const getPathWithHashedParameters = (routeObj) => {
  const replaceParametersForHash = (path, parameters) => {
    let newPath = path;
    parameters.forEach(param => {
      newPath = newPath.replace(new RegExp(param, 'g'), hashString(param));
    });
    return newPath;
  };

  let { path } = routeObj;

  // hash all path parameters
  path = replaceParametersForHash(path, Object.values(routeObj.params));

  // hash all query parameters
  path = replaceParametersForHash(path, Object.values(routeObj.query));

  return path;
};

export function createEventTracking(
  _ga = ga,
  _EventManager = EventManager,
  _GlobalEventBus = GlobalEventBus,
) {
  return function eventTracking(to, from) {
    const { path } = to;

    // Only track the event if we're navigation to a Vue page
    if (to.matched.length > 0) {
      const cleanedPath = path.replace('/', '');

      try {
        _ga('send', 'pageview', { page: path });
      } catch (e) {
        LoggingService.error('failed to send ga page view event: ', e);
      }

      try {
        _EventManager.handlePageVisited(cleanedPath);
      } catch (e) {
        LoggingService.error('failed to handling page visited: ', e);
      }

      try {
        UiEvents.triggerPageViewed({
          fromUrl: `${window.location.hostname}${getPathWithHashedParameters(from)}`,
          toUrl: `${window.location.hostname}${getPathWithHashedParameters(to)}`,
          description: 'Page Viewed',
          page: 'n/a',
        });
      } catch (e) {
        LoggingService.error('failed to handling page viewed: ', e);
      }

      try {
        _GlobalEventBus.emitPageViewEvent(cleanedPath);
      } catch (e) {
        LoggingService.error('failed sending page view event: ', e);
      }
    }
  };
}

export default createEventTracking();
